import { styled, Tooltip, tooltipClasses,TooltipProps } from "@mui/material";

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 15px 0px',
    backgroundColor: '#FFF8FA',
    color: '#BF295C',
    maxWidth: 185,
    fontSize: '14px',
    fontWeight: '400',
    padding: '10px 16px',
    borderRadius: '6px',
    wordWrap: 'break-word',
  },
}));